import { render, staticRenderFns } from "./MarketplaceOrdersIndex.vue?vue&type=template&id=ec3a8ac4&"
import script from "./MarketplaceOrdersIndex.vue?vue&type=script&lang=js&"
export * from "./MarketplaceOrdersIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports